import Container from "./Container";
import ContainerFluid from "./ContainerFluid";
import Row from "./Row";
import Col from "./Col";

const Grid = { Container, ContainerFluid, Row, Col };

export default Grid;
